import { render, staticRenderFns } from "./voteResult.vue?vue&type=template&id=4c4c62ba&scoped=true"
import script from "./voteResult.vue?vue&type=script&lang=js"
export * from "./voteResult.vue?vue&type=script&lang=js"
import style0 from "./voteResult.vue?vue&type=style&index=0&id=4c4c62ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c62ba",
  null
  
)

export default component.exports